import { c as _c } from "react/compiler-runtime";
import { useGameAnalysis } from '@svs/nova-poolbetting/core/frameworks/nextjs/analysis';
import type { Outcome } from '@svs/nova-poolbetting/schema/coupon';
import type { DrawNumber } from '@svs/nova-poolbetting/schema/draw';
import type { Definition } from '@svs/nova-poolbetting/schema/frameworks';
import type { EventNumber } from '@svs/nova-poolbetting/schema/sport';
import type { ReactNode } from 'react';
type GameAnalysisContainerProps = {
  product: Definition['moduleEngine'];
  drawNumber: DrawNumber;
  eventNumber: EventNumber;
  renderItem: (props: {
    eventAnalyses?: {
      eventOutcome: (Outcome | undefined)[];
      authorName: string;
    }[];
  }) => ReactNode;
};

/**
 * Game analysis container component.
 *
 * @param root0 props
 * @param root0.product product to get game analysis for
 * @param root0.drawNumber draw number to get game analysis for
 * @param root0.eventNumber event number to get game analysis for
 * @param root0.renderItem render item function
 * @returns game analysis container component
 */
export function GameAnalysisContainer(t0) {
  const $ = _c(9);
  const {
    product,
    drawNumber,
    eventNumber,
    renderItem
  } = t0;
  const gameAnalysis = useGameAnalysis(product, drawNumber);
  if (gameAnalysis.isError) {
    let t1;
    if ($[0] !== renderItem) {
      t1 = renderItem({
        eventAnalyses: undefined
      });
      $[0] = renderItem;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  let t2;
  if ($[2] !== eventNumber || $[3] !== gameAnalysis.data || $[4] !== renderItem) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const eventAnalyses = gameAnalysis.data.length > 0 ? gameAnalysis.data.map(analysis => {
        const eventAnalysis_0 = analysis.eventAnalyses.find(eventAnalysis => eventAnalysis.properties.eventNumber === eventNumber);
        const eventOutcome = eventAnalysis_0?.properties.prediction?.predictions[0]?.outcomes[0];
        const authorName = analysis.authorProfile.shortName;
        return {
          eventOutcome: [eventOutcome],
          authorName
        };
      }) : [];
      if (eventAnalyses.length === 0) {
        let t3;
        if ($[7] !== renderItem) {
          t3 = renderItem({
            eventAnalyses: undefined
          });
          $[7] = renderItem;
          $[8] = t3;
        } else {
          t3 = $[8];
        }
        t2 = t3;
        break bb0;
      }
      t1 = renderItem({
        eventAnalyses
      });
    }
    $[2] = eventNumber;
    $[3] = gameAnalysis.data;
    $[4] = renderItem;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  return t1;
}